/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

/**
 * Admin Header component
 *
 * @param {Object} props
 * @param {string} props.version    Plugin version string.
 * @param {string} props.pageName   Current page label (e.g. "Events", "Bookings").
 *
 * @return {JSX.Element} The Header component.
 */
const Header = ({ version = '', pageName = '' }) => {
    return (
        <div className="nb-bg-slate-700 nb-text-white nb-px-6 nb-py-3">
            <div className="nb-flex nb-justify-between nb-items-center nb-mx-auto">
                <div className="nb-flex nb-items-center nb-gap-3">
                    <h1 className="!nb-text-xl nb-font-semibold !nb-m-0 !nb-p-0 nb-text-white">
                        {__('Nemtly Booking', 'nemtly-booking')}
                    </h1>
                    {pageName && (
                        <>
                            <span className="nb-text-slate-400 nb-text-lg nb-font-light">/</span>
                            <span className="nb-text-slate-200 nb-text-base nb-font-medium">
                                {pageName}
                            </span>
                        </>
                    )}
                    {version && (
                        <span className="nb-bg-slate-600 nb-text-slate-300 nb-px-2 nb-py-0.5 nb-rounded nb-text-xs nb-font-medium">
                            v{version}
                        </span>
                    )}
                </div>
                <div className="nb-flex nb-items-center nb-gap-3">
                    <a
                        href="https://nemtly-booking.canny.io/feature-requests"
                        target="_blank"
                        className="nb-text-slate-300 hover:nb-text-white nb-text-xs nb-font-medium nb-no-underline nb-transition-colors"
                        rel="noopener noreferrer"
                    >
                        {__('Feature Ideas', 'nemtly-booking')}
                    </a>
                    <span className="nb-text-slate-500 nb-text-xs">|</span>
                    <a
                        href="https://wordpress.org/support/plugin/nemtly-booking/"
                        target="_blank"
                        className="nb-text-slate-300 hover:nb-text-white nb-text-xs nb-font-medium nb-no-underline nb-transition-colors"
                        rel="noopener noreferrer"
                    >
                        {__('Support', 'nemtly-booking')}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Header;
